import { render, staticRenderFns } from "./PlatformUpdateBanner.vue?vue&type=template&id=d24788e4&scoped=true&"
import script from "./PlatformUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./PlatformUpdateBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlatformUpdateBanner.vue?vue&type=style&index=0&id=d24788e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24788e4",
  null
  
)

export default component.exports